import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { CSSProperties, FunctionComponent } from 'react';
import IconBox from './Chevron.style';

interface Props {
  containerStyle?: CSSProperties;
  size: number;
  color?: string;
  direction?: 'left' | 'right';
}

const Chevron: FunctionComponent<Props> = (props) => {
  return (
    <IconBox style={props.containerStyle}>
      <FontAwesomeIcon
        icon={props.direction === 'left' ? faChevronLeft : faChevronRight}
        style={{ fontSize: props.size }}
      />
    </IconBox>
  );
};

export default Chevron;
